import { MODULE_LINK_TYPE } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/assessment/build/${seriesId}/${moduleId}`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/assessment/track/${seriesId}/${moduleId}`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/assessment/overview?gameType=assessment&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
